import {
    ExpenseSubMode,
    RevenueSubMode,
} from "@common/types/domains/accounting/schedule";

export interface ScheduleSubModes {
    revenueSubMode: RevenueSubMode | null;
    expenseSubMode: ExpenseSubMode | null;
}

/** Accrued revenue or accrued expense: recognized before it's billed. */
export function isAccruedScheduleMode(
    subModes: Partial<ScheduleSubModes>,
): boolean {
    return (
        subModes.revenueSubMode === RevenueSubMode.accrued ||
        subModes.expenseSubMode === ExpenseSubMode.accrued
    );
}
